<!-- <template>
  <div class="class-record-page">
    <h1>我的收藏院校</h1>
    <div v-if="favoriteSchools.length === 0" class="no-data">
      暂无收藏院校，请前往院校列表页添加收藏。
    </div>

    <div v-else class="favorite-list">
      <el-card
        v-for="school in favoriteSchools"
        :key="school.id"
        class="favorite-school-card"
      >
        <template #header>
          <div class="card-header">
            <img :src="school.logo" alt="Logo" class="school-logo" />
            <div class="school-info">
              <h3>{{ school.name }}</h3>
              <p>{{ school.type }} | {{ school.address }}</p>
            </div>
          </div>
        </template>
        <div class="school-details">
          <p><strong>招生性别：</strong>{{ school.nature }}</p>
          <p><strong>招生类别：</strong>{{ school.discipline_level }}</p>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script setup>
import { useFavoriteStore } from "@/store";
import { storeToRefs } from "pinia";

const favoriteStore = useFavoriteStore();
const { favoriteSchools } = storeToRefs(favoriteStore); // 响应式引用
</script>

<style scoped>
.class-record-page {
  max-width: 1200px;
  margin: auto;
  padding: 10px;
}

.no-data {
  text-align: center;
  color: #999;
  font-size: 16px;
}

.favorite-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
  margin-top: 20px;
}

.favorite-school-card {
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.school-logo {
  width: 60px;
  height: 60px;
  object-fit: cover;
  margin-right: 15px;
}

.card-header {
  display: flex;
  align-items: center;
}
</style> -->
<template>
  <div class="class-record-page">
    <h1>我的收藏院校</h1>

    <!-- 加载状态 -->
    <div v-if="loading" class="loading">正在加载收藏数据...</div>
    <!-- 错误状态 -->
    <div v-else-if="error" class="error">{{ error }}</div>
    <!-- 无数据状态 -->
    <div v-else-if="favoriteSchools.length === 0" class="no-data">
      暂无收藏院校，请前往院校列表页添加收藏。
    </div>
    <!-- 数据展示 -->
    <div v-else class="favorite-list">
      <el-card
        v-for="school in favoriteSchools"
        :key="school.id"
        class="favorite-school-card"
      >
        <template #header>
          <div class="card-header">
            <img
              :src="baseURL + school.logo"
              alt="Logo"
              class="school-logo"
            />
            <div class="school-info">
              <h3>{{ school.name }}</h3>
              <p>{{ school.type }} | {{ school.address }}</p>
            </div>
          </div>
        </template>
        <div class="school-details">
          <p><strong>招生性别：</strong>{{ school.nature }}</p>
          <!-- <p>
            <strong>招生类别：</strong
            >{{ school.discipline_level || "暂无数据" }}
          </p> -->
        </div>
      </el-card>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { ElMessage } from "element-plus";
import axios from "@/api/axiosConfig";
import { baseURL } from "@/api/axiosConfig";

// 收藏院校列表
const favoriteSchools = ref([]);
// 加载状态
const loading = ref(false);
// 错误信息
const error = ref(null);

// 从后端获取数据
onMounted(async () => {
  const auth = JSON.parse(localStorage.getItem("auth"));
  // console.log("-----------");
  // console.log(token);
  if (!auth || !auth._token) {
    ElMessage.warning("请先登录");
    return;
  }
  const token = auth._token;

  loading.value = true;
  try {
    const res = await axios.post("/interface/schoolcollect/schoolcollectlist", {
      token,
    });
    console.log("----------");
    console.log("Fetch favorites response:", res.data); // 打印响应数据
    if (res.data.code === 200) {
      favoriteSchools.value = res.data.data || [];
    } else {
      throw new Error(res.data.msg || "获取收藏失败");
    }
  } catch (err) {
    error.value = err.message || "网络异常，请稍后再试";
    console.error("获取收藏失败:", err);
  } finally {
    loading.value = false;
  }
});
</script>

<style scoped>
.class-record-page {
  max-width: 1200px;
  margin: auto;
  padding: 20px;
}

.loading,
.no-data,
.error {
  text-align: center;
  color: #999;
  font-size: 16px;
  padding: 40px 0;
}

.favorite-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
  margin-top: 20px;
}

.favorite-school-card {
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.school-logo {
  width: 60px;
  height: 60px;
  object-fit: cover;
  margin-right: 15px;
}

.card-header {
  display: flex;
  align-items: center;
}
</style>
<!-- 
<script setup>
import { ref, onMounted } from "vue";
import axios from "@/api/axiosConfig";

// 收藏院校列表
const favoriteSchools = ref([]);
// 加载状态
const loading = ref(false);
// 错误信息
const error = ref(null);

// 从后端获取数据
onMounted(async () => {
  const token = localStorage.getItem("token");
  if (!token) {
    error.value = "未检测到登录信息，请先登录";
    return;
  }

  loading.value = true;
  try {
    const res = await axios.post("/interface/schoolcollect/schoolcollectlist", {
      token,
    });

    if (res.data.code === 200) {
      favoriteSchools.value = res.data.data || [];
    } else {
      throw new Error(res.data.msg || "获取收藏失败");
    }
  } catch (err) {
    error.value = err.message || "网络异常，请稍后再试";
    console.error("获取收藏失败:", err);
  } finally {
    loading.value = false;
  }
});
</script>

<style scoped>
.class-record-page {
  max-width: 1200px;
  margin: auto;
  padding: 20px;
}

.loading,
.no-data,
.error {
  text-align: center;
  color: #999;
  font-size: 16px;
  padding: 40px 0;
}

.favorite-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
  margin-top: 20px;
}

.favorite-school-card {
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.school-logo {
  width: 60px;
  height: 60px;
  object-fit: cover;
  margin-right: 15px;
}

.card-header {
  display: flex;
  align-items: center;
}
</style> -->
